export const MOBILE_NAVIGATION = [
  { to: "/mobile", key: "home", moduleKey: "dashboard", exact: true },
  { to: "/mobile/calendar", key: "calendar", moduleKey: "leaveManagement", exact: false },
  { to: "/mobile/inbox?tab=notifications", key: "inbox", moduleKey: "notifications", exact: false },
  { to: "/mobile/salary", key: "salary", moduleKey: "salary", exact: false },
  { to: "/mobile/profile", key: "profile", moduleKey: "myProfile", exact: false },
] as const;

export function getMobileNavigation(canAccess: (key: string) => boolean) {
  return MOBILE_NAVIGATION.filter(item => canAccess(item.moduleKey));
}
